// Libs
import path from "path";
import querystring from "querystring";
import { ROUTES, ROUTE_PARAMS } from "constants/routing";

const logoutRegex = new RegExp(`^${ROUTES.LOGOUT}`, "i");

const _getRedirectURL = () => {
  let redirect = "";

  if (!logoutRegex.test(window.location.pathname)) {
    return `redirect=${encodeURIComponent(window.location.href)}`;
  }

  return redirect;
};

export function getCleanPath(paths = []) {
  return path.join(
    ...paths.map(path => {
      if (typeof path === "undefined") {
        return "";
      }
      if (typeof path === "number") {
        return path.toString();
      }
      return path;
    })
  );
}

/**
 * Navigates to the given path(s) using the router's history object.
 * @param {object} history Router history object
 * @param  {...string} paths Paths to join and navigate to
 */
export function navigateTo(history, ...paths) {
  history.push(getCleanPath(paths));
}

/**
 * Navigates with a particular search query
 * @param {object} history
 * @param {array} paths List of paths that will be joined together
 * @param {object} queryParams Object of query parameters in this format { param1: value1, ... }
 */
export function navigateToWithQuery(history, paths, queryParams) {
  history.push({
    pathname: getCleanPath(paths),
    search: `?${querystring.stringify(queryParams)}`
  });
}

/**
 * Passthrough to navigateTo that wraps it in a function for use in onClick handlers.
 * @param  {...any} args
 */
export function navigateOnClick(...args) {
  return function() {
    return navigateTo(...args);
  };
}

export function navigateToLogin() {
  let redirect = _getRedirectURL();
  window.location.href = `/?${redirect}`;
}

export function navigateToNewLogin() {
  let redirect = _getRedirectURL();
  window.location.href = `/logout?${redirect}`;
}

/**
 * When a user lands on /welcome, redirect to /sponsorRegistration with token
 * @param {string} queryParams.token Token for onboarding user
 */
export function navigateToRegistration({ token }) {
  window.location.href = `/sponsorRegistration?${ROUTE_PARAMS.TOKEN}=${encodeURIComponent(token)}`;
}
